import {
  UserNameExistWithTheme,
  UserSignUpWithTheme,
  loadRecaptcha,
} from "../../api";
import { useAuth } from "../../hooks";
import {
  validateConfirmPassword,
  validateUserName,
} from "../../Utils/helperFunction";
import { validatePassword } from "../../validation";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import SignUpFlow from "../../Container/Auth/Layout";
import { EditIcon } from "../../Public/assets";
import { Input, PasswordInput } from "../ui/input";
import ButtonLoader from "../Loader";

function CreatePass() {
  const [searchParams] = useSearchParams();
  const initialEmail = searchParams.get("email") || "";
  const [toggleUserName, setToggleUserName] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    password: "",
    confirmPass: "",
    userName: "",
  });

  const {
    formData,
    signupOtpToken,
    signupOtp,
    confirmPass,
    setConfirmPass,
    password,
    setPassword,
    userName,
    setStateVariable,
    setUserName,
    normalizeFormData,
  } = useAuth();

  useEffect(() => {
    loadRecaptcha();
  }, []);

  useEffect(() => {
    if (!initialEmail) {
      navigate("/");
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setUserName(initialEmail);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUserNameChange = (e) => {
    const value = e.target.value;
    setUserName(value);
    setErrors((prev) => ({ ...prev, userName: "" }));
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setErrors((prev) => ({ ...prev, password: "" }));
  };

  const handleFieldBlurPass = (e) => {
    const passwordValidationErrors = validatePassword(e.target.value);
    setErrors((prev) => ({
      ...prev,
      password:
        passwordValidationErrors.length > 0 ? passwordValidationErrors[0] : "",
      confirmPass: e.target.value === confirmPass ? "" : errors.confirmPass,
    }));
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPass(value);
    setErrors((prev) => ({ ...prev, confirmPass: "" }));
  };

  const handleFieldBlurUserName = async () => {
    try {
      if (userName) {
        const userNameUnique = await UserNameExistWithTheme(userName);
        if (!userNameUnique) {
          setErrors((prev) => ({
            ...prev,
            userName: "Username already exists",
          }));
        }
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        userName: error?.message || "Error checking username",
      }));
    }
  };

  const handleFieldBlurConfirmPass = (e) => {
    const error = validateConfirmPassword(e.target.value, password);
    setErrors((prev) => ({ ...prev, confirmPass: error }));
  };

  const SignUpData = {
    username: userName || initialEmail,
    email: initialEmail || formData?.email,
    password: password,
    otp: signupOtp,
    otpToken: signupOtpToken,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    normalizeFormData();
    setLoading(true);
    // Validate the form on submit
    const userNameError = toggleUserName ? validateUserName(userName) : "";
    const passwordValidationErrors = validatePassword(password);
    const confirmPassError = validateConfirmPassword(confirmPass, password);
    // Update errors state with form validation errors
    const validationErrors = {
      userName: userNameError,
      password:
        passwordValidationErrors.length > 0 ? passwordValidationErrors[0] : "",
      confirmPass: confirmPassError,
    };
    setErrors(validationErrors);
    // Stop further processing if validation errors exist
    if (
      userNameError ||
      passwordValidationErrors.length > 0 ||
      confirmPassError
    ) {
      setLoading(false);
      return;
    }

    // Check if username is unique (if required)
    if (toggleUserName && userName !== "") {
      try {
        const userNameUnique = await UserNameExistWithTheme(userName);
        if (!userNameUnique) {
          setErrors((prev) => ({
            ...prev,
            userName: "Username already exists",
          }));
          return;
        }
      } catch (error) {
        setLoading(false);
        setErrors((prev) => ({
          ...prev,
          userName: error?.message || "Error checking username",
        }));
        console.log("Username check error:", error);
        return;
      }
    }

    try {
      await UserSignUpWithTheme(SignUpData);
      setPassword("");
      setConfirmPass("");
      setLoading(false);
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        signUp: error?.response?.data?.message || error?.message || "Error during sign-up process",
      }));
      setLoading(false);
      return;
    }

    // Proceed to the next flow if no errors
    navigate("/details", { replace: true });
    setLoading(false);
    setStateVariable(1);
  };

  return (
    <SignUpFlow headerText={"Create an account"}>
      <div className="w-full">
        <p className="text-[16px] mb-[12px] text-greyish font-geomanistRegular">
          Please create a password for the username associated with your
          account.
        </p>

        {!toggleUserName && (
          <div className=" w-full  flex justify-between bg-greyShade rounded-[8px] p-[18px] mb-[12px]">
            <div className="flex  max-w-[80%]  flex-col gap-[2px]">
              <p className="leading-[30px]  font-geomanistBold text-[16px] text-blackShade">
                Assigned Login Username
              </p>
              <p className="leading-[26px] truncate font-geomanistRegular text-[16px] text-blackShade">
                {initialEmail}
              </p>
            </div>
            <div
              className="  p-[14px] hover:cursor-pointer"
              onClick={() => setToggleUserName(true)}
            >
              <img src={EditIcon} alt="" />
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className={`space-y-[12px] mb-[27px]`}>
            {toggleUserName && (
              <div>
                <label
                  htmlFor="Username"
                  className="block text-[16px] font-geomanistRegular text-greyish mb-[9px] ml-2"
                >
                  User Name
                </label>
                <Input
                  id="Username"
                  type="text"
                  value={userName}
                  onBlur={handleFieldBlurUserName}
                  onChange={handleUserNameChange}
                  className={`w-full h-[45px] px-3 py-2 font-geomanistBold text-[16px] ${
                    errors.userName ? "border-red-500" : ""
                  }`}
                />
                {errors.userName && (
                  <p className="text-red-500 text-[14px] mt-1 ml-2">
                    {errors.userName}
                  </p>
                )}
              </div>
            )}

            <div>
              <label
                htmlFor="password"
                className="block text-[16px] font-geomanistRegular text-greyish mb-[9px] ml-2"
              >
                Create Password
              </label>
              <PasswordInput
                id="password"
                value={password}
                onBlur={handleFieldBlurPass}
                onChange={handlePasswordChange}
                error={errors.password}
                className={`w-full h-[45px] px-3 py-2 font-geomanistBold text-[16px] ${
                  errors.password ? "border-red-500" : ""
                }`}
              />
              {errors.password && (
                <p className="text-red-500 text-[14px] mt-1 ml-2">
                  {errors.password}
                </p>
              )}
            </div>

            <div>
              <label
                htmlFor="confirmPassword"
                className="block text-[16px] font-geomanistRegular text-greyish mb-[9px] ml-2"
              >
                Confirm Password
              </label>
              <Input
                id="confirmPassword"
                type="password"
                value={confirmPass}
                onChange={handleConfirmPasswordChange}
                onBlur={handleFieldBlurConfirmPass}
                className={`w-full h-[45px] px-3 py-2 font-geomanistBold text-[16px] ${
                  errors.confirmPass ? "border-red-500" : ""
                }`}
              />
              {errors.confirmPass && (
                <p className="text-red-500 text-[14px] mt-1 ml-2">
                  {errors.confirmPass}
                </p>
              )}
              {!errors.confirmPass && (
                <h1 className="font-geomanistRegular text-[14px] mt-1 text-greyish">
                  Password should be a min. of 8 characters with a mix of
                  letters, numbers & symbols (Example: Abcd@123)
                </h1>
              )}
            </div>
          </div>
          {errors.signUp && (
            <p className="text-red-500 text-[14px] mb-2 text-center">
              {errors.signUp}
            </p>
          )}
          <button
            disabled={loading}
            type="submit"
            className="w-full  flex justify-center mt-[28px] text-white py-[10px] px-4 rounded-md bg-blueish font-geomanistMedium leading-[23px] text-[18px] hover:pointer"
          >
            {loading && <ButtonLoader className={"mr-2 h-2"} />} Continue
          </button>
        </form>

        <p className="text-center mt-[12px] text-[16px] text-blackShade font-geomanistRegular">
          By signing up, I agree to the
          <a
            href="https://www.airwallex.com/sg/terms/stockal"
            target="_blank"
            rel="noreferrer"
            className="text-blueish hover:text-blue-500 font-geomanistBold cursor-pointer px-1"
          >
            Terms & Conditions
          </a>
          and the
          <a
            href="https://help.stockal.com/portal/en/kb/articles/user-agreement"
            target="_blank"
            rel="noreferrer"
            className="text-blueish hover:text-blue-500 font-geomanistBold cursor-pointer px-1"
          >
            User License Agreement
          </a>
        </p>
      </div>
    </SignUpFlow>
  );
}

export default CreatePass;
